<template>
    <div class="purchasingType padding-20 bgc box-shadow">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'PurchasingType',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.purchasingType {
}
</style>
